
<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>Perfis</v-toolbar-title>
      <v-spacer></v-spacer>

      <ProfileFormDlg
        :addButton="profilesPermissions && profilesPermissions.edit"
        :dialog="frmProfileDialog"
        :openForm="() => openDialogForm()"
        :closeForm="() => closeDialogForm()"
        :saveProfile="(data) => saveProfile(data)"
        :editFormData="formData"
      />
    </v-toolbar>

    <SearchProfiles :searchProfiles="(profile) => getProfiles(profile)" />

    <v-data-table :headers="headers" :items="tableData">
      <template v-slot:items="props">
        <td class="text-xs-left">{{ props.item.name }}</td>
        <td class="text-xs-center">
          {{ props.item.updated_at | moment("DD/MM/YYYY") }}
        </td>
        <td class="text-xs-center layout">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                v-if="profilesPermissions.edit"
                small
                class="mr-2"
                @click="editItem(props.item)"
                >edit</v-icon
              ></template
            >
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                v-if="profilesPermissions.view"
                small
                class="mr-2"
                @click="editItem(props.item, 'viewForm')"
                >remove_red_eye</v-icon
              ></template
            >
            <span>Visualizar</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                v-if="profilesPermissions.remove"
                small
                @click="confirmDelProfile(props.item)"
                >delete</v-icon
              ></template
            >
            <span>Excluir</span>
          </v-tooltip>
        </td>
      </template>
      <template v-slot:no-data>
        <p>Não há dados</p>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import ProfileFormDlg from '@/components/profiles/ProfilesForm.vue'
import SearchProfiles from '@/components/profiles/SearchProfiles.vue'
import {
  profiles as profilesService,
  addProfile as addProfileService,
  updateProfile as updateProfileService
} from '@/services/profiles'

const resquestToSaveProfile = {
  patch: updateProfileService,
  post: addProfileService
}

export default {
  name: 'Profiles',

  components: {
    ProfileFormDlg,
    SearchProfiles
  },

  data () {
    return {
      frmProfileDialog: false,
      formData: null,
      headers: [
        { text: 'Nome do perfil', sortable: true, value: 'name' },
        {
          text: 'Última alteração',
          value: 'updated_at',
          sortable: false,
          align: 'center'
        },
        { text: ' ', value: '', sortable: false, align: 'center' }
      ],
      tableData: []
    }
  },

  mounted () {
    this.getProfiles()
  },

  computed: {
    profilesPermissions () {
      return this.$store.state.permissions.permissions.profile
    }
  },

  methods: {
    confirmDelProfile (data) {
      let obj = {
        message: `Você deseja excluir o perfil "${data.name}"?`,
        title: 'Excluir perfil',
        callback: (_) => {
          this.delProfile(data)
        },
        type: 'warning',
        btConfirm: { name: 'Sim', show: true },
        btCancel: { name: 'Não', show: true }
      }
      this.$store.commit('confirmMessage/showConfirmMessage', obj)
    },

    delProfile (data) {
      let obj = {
        url: '/api/profile/' + data.id,
        query: '',
        method: 'delete'
      }
      this.$store.dispatch('request/doRequest', obj).then((response) => {
        if (!response) {
          return
        }
        let opts = {
          message: `Usuário removido com sucesso`,
          type: 'success'
        }
        this.$store.commit('showAlert', opts)
        this.getProfiles()
      })
    },

    openDialogForm () {
      this.formData = null
      this.frmProfileDialog = true
    },

    closeDialogForm () {
      this.frmProfileDialog = false
    },

    async getProfiles (searchParams = {
      name: ''
    }) {
      this.$store.commit('showLoader', {
        circle: true
      })

      const response = await profilesService(searchParams)

      this.tableData = response

      this.$store.commit('hideLoader')
    },

    editItem (item, view) {
      if (!item.permissions_id) {
        item.permissions_id = item.permissions.map((perm) => {
          return perm.id
        })
      }

      view === 'viewForm' ? (item.view = true) : (item.view = false)

      this.formData = Object.assign({}, item)
      this.frmProfileDialog = true
    },

    async saveProfile (profile) {
      this.$store.commit('showLoader', {
        circle: true
      })

      const requestMethod = profile.id ? 'patch' : 'post'

      await resquestToSaveProfile[requestMethod](profile)

      this.responseSave(profile.id)

      this.$store.commit('hideLoader')
    },

    responseSave (edit) {
      let opts = {
        message: `Perfil ${edit.id ? 'alterado' : 'criado'} com sucesso`,
        type: 'success'
      }

      this.$store.commit('showAlert', opts)

      this.frmProfileDialog = false
      this.getProfiles()
    }
  }
}
</script>

<style scoped>
  .layout {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
</style>
